import React from 'react'
import Confirmation from '../../components/User/MembershipConfirmation';

const MembershipConfirmation = () => {
  return (
    <Confirmation />
  )
}

export default MembershipConfirmation;